import { securePost } from "../../Config/ApiConfig";

export const facebookRegister = async (body) => {
    const { data } = await securePost('/auth/facebook-register', body);
    return data;
  };